import React from 'react'
import { useState, useEffect } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import GetfacilityTypeData from './MyMapUtils/GetfacilityTypeData';
import GetManagementStatus from './MyMapUtils/GetManagementStatus';
import searchFacet from './MyMapUtils/searchFacet';

export default function FilterPopup(props) {
    const [checkedTypes, setCheckedTypes] = useState(props.targetTypes);
    const [existsTypes, setExistsTypes] = useState([]);
    const [isSearching, setIsSearching] = useState(true);
    const [date_str, setDate_str] = useState(props.DateTime_str);
    const [date_end, setDate_end] = useState(props.DateTime_end);
    const [checkedType, setCheckedType] = useState(props.targetType);
    function onClearClick() {
        setCheckedTypes([]);
        setDate_str("");
        setDate_end("");
        setCheckedType("");
    }

    const handleClose = () => {
        switch(props.popupKind){
            case "date":
                if(date_str !== props.DateTime_str || date_end !== props.DateTime_end){
                    props.onApplyFilter_date(props.filterKind_str,date_str,props.filterKind_end,date_end);
                }
                break;
            case "radio":
                //onClickRadioButton()で更新済み
                break;
            default:
                if (!stringArrayEquals(props.targetTypes, checkedTypes)) {
                    props.onApplyFilter(checkedTypes);
                }
                break;
        }
        
        props.onClose();
    };

    useEffect(() => {
        //日付入力の場合は選択肢用の検索をせず、即時表示（ラジオも同様）
        if(props.popupKind === "date" || props.popupKind === "radio"){
            setIsSearching(false);
        }
        else{
            search();
        }
    }, [props.filterKind]);

    function search() {
        setIsSearching(true);
        searchFacet(props.filterKind, props.userAuthorities, props.keyword, props.filters,props.viewtype)
            .then(response => response.json())
            .then(
                (result) => {
                    console.log(result);
                    procOnSearch(result);
                },
                (error) => {
                    console.log(error);
                }
            )
            .finally(() => {
                setIsSearching(false);
            });
    }
    function procOnSearch(result) {
        // 空白のfacetは取り除く。 nullは取得されないので、空白で検索されると都合が悪い
        let facets = result['@search.facets'][props.filterKind]?.filter(item => item.value !== "");
        // facets に存在しない checkedTypes を追加。
        let toAddFacets = [];
        checkedTypes?.forEach(item => {
            if (!facets.some(facet => facet.value === item)) {
                toAddFacets.push({ value: item, count: 0 });
            }
        });
        facets = facets.concat(toAddFacets);

        //通報（匿名）かつステータスの場合、「市確認中」を必須表示する特殊処理
        if(props.viewtype === "report" && props.filterKind === "reportStatus"){
            if (!facets.some(facet => facet.value === "1")) {
                facets.push({ value: "1", count: 0 });
            }
        }

        // 並べ替え
        facets.sort((a, b) => {
            if (a.value > b.value)
                return 1;
            else
                return -1;
        });
        setExistsTypes(facets);
    }

    function onClickRadioButton(item){
        setCheckedType(item);

        if (item !== props.targetType) {
            props.onApplyFilter(item);
        }

        handleClose();
    }

    return (
        <ClickAwayListener onClickAway={handleClose}>
        <div role="dialog" className="hovercard noprint">
                <div className="hovercard-content">
                    {isSearching ?
                        <CircularProgress size={20} />
                        :
                        props.popupKind === "date"?
                            <div className="hovercard-Date">
                                <input type="date"
                                    value={date_str}
                                    onChange={(e)=>setDate_str(e.target.value)}
                                    max={date_end}
                                    />
                                <span style={{margin:'0 5px'}}>～</span>
                                <input type="date"
                                    value={date_end}
                                    onChange={(e)=>setDate_end(e.target.value)}
                                    min={date_str}
                                    />
                            </div>
                            :
                            props.popupKind === "radio" ?
                            <ul role="group" className="hovercard-items">
                                <li key={"pavement100"} aria-checked="false" role="radio" className="hovercard-item" onClick={() => {onClickRadioButton("pavement100")}}>
                                    <div className="hovercard-check">
                                        <i className={checkedType === "pavement100" ? "bi bi-circle-fill" : "bi bi-circle"}></i>
                                    </div>
                                    <div className="hovercard-text">
                                            <span>100ｍ単位</span>
                                    </div>
                                </li>
                                <li key={"pavement10"} aria-checked="false" role="radio" className="hovercard-item" onClick={() => {onClickRadioButton("pavement10")}}>
                                    <div className="hovercard-check">
                                        <i className={checkedType === "pavement10" ? "bi bi-circle-fill" : "bi bi-circle"}></i>
                                    </div>
                                    <div className="hovercard-text">
                                            <span>10ｍ単位</span>
                                    </div>
                                </li>
                                
                            </ul>

                        :
                            <ul role="group" className="hovercard-items">
                                {existsTypes && existsTypes.map((existsType) =>
                                    <li key={existsType.value} aria-checked="false" role="checkbox" className="hovercard-item" onClick={() => {
                                        let newCheckedTypes
                                        if (checkedTypes.includes(existsType.value)) {
                                            newCheckedTypes = checkedTypes.filter(type => type !== existsType.value)
                                        } else {
                                            newCheckedTypes = [...checkedTypes, existsType.value]
                                        }
                                        sortValues(newCheckedTypes);
                                        setCheckedTypes(newCheckedTypes);
                                    }}>
                                        <div className="hovercard-check">
                                            <i className={checkedTypes.includes(existsType.value) ? "bi bi-check-square-fill" : "bi bi-square"}></i>
                                        </div>

                                        {props.isFacilityType &&
                                            <div className="hovercard-image"><img src={GetfacilityTypeData(existsType.value,"icon")} className="facility-icon" alt="" /></div>
                                        }

                                        <div className="hovercard-text">
                                            <span>
                                                {props.isFacilityType ?
                                                    GetfacilityTypeData(existsType.value,"name")
                                                    :
                                                    props.masterKind ?
                                                        GetManagementStatus(props.masterKind,existsType.value,"name")
                                                        :
                                                        existsType.value
                                                }
                                            </span>
                                            <span className="hovercard-count"> ({existsType.count})</span>
                                        </div>
                                    </li>
                                    
                                )}
                            </ul>
                    }

                </div>
                {props.popupKind !== "radio" && 
                    <div className="hovercard-buttons">
                        <button className="hovercard-button" onClick={onClearClick}>
                            <span className="hovercard-buttontext">クリア</span>
                        </button>
                        <button className="hovercard-button hovercard-lastbutton" onClick={handleClose}>
                            <span className="hovercard-buttontext hovercard-done">適用</span>
                        </button>
                    </div>
                }
            </div>
        </ClickAwayListener>
    );
}
function sortValues(arr) {
    arr.sort((a, b) => {
        if (a > b)
            return 1;
        else
            return -1;
    });
}
function stringArrayEquals(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}